export default "__VITE_ASSET__f165c85a__"